import { Dialog } from 'primereact/dialog';

const CotizacionesEnviadasDialog = ({ visible, onHide }) => {
    return (
        <Dialog 
            header="Cotizaciones Enviadas (Últimos 30 días)" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
        >
            <div className="grid">
                <div className="col-12 md:col-4">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Últimos 30 días</div>
                        <div className="text-4xl text-blue-500 font-bold">2</div>
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Evolución del mes</div>
                        <div className="text-4xl text-orange-500 font-bold">2</div>
                    </div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Esta semana</div>
                        <div className="text-4xl text-green-500 font-bold">1</div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default CotizacionesEnviadasDialog;